import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {UserRole} from '../../enums/user-role';
import {DexLpTradeWidgetImplementation} from './dex-lp-trade-widget-implementation';
import {DEX_LP_TRADE_WIDGET_TYPE_ID} from './dex-lp-trade-widget-type-id';
import {DexLpTradeWidgetComponent} from './dex-lp-trade-widget.component';
import {DexLpTradeWidgetSettingsService} from './settings';

export const DEX_LP_TRADE_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_LP_TRADE_WIDGET_TYPE_ID,
    widgetLabel:               'Purchase/Redeem Tranche Units',
    widgetImplementationType:  DexLpTradeWidgetImplementation,
    widgetComponentType:       DexLpTradeWidgetComponent,
    widgetSettingsServiceType: DexLpTradeWidgetSettingsService,
    settingsSchema:            [
        {
            name: 'title',
            isShareable: false
        },
        {
            name: 'symbol',
            isShareable: true,
            sharedName: 'trancheSymbol'
        }
    ],
    hasGroupingSupport: true,
    widgetSettingsComponentType: null,
    defaultWidgetSize: [568, 370], // The size in pixels is got by measuring the widget's outer DOM element.
    userRoles: [UserRole.TRADER, UserRole.TRADER_ADMIN]
};
